/** USP Text **/
waitForElement('.cp-usp-rotator', function(root) {
    if (!root || root.classList.contains('cp-usp-ready')) return;
    root.classList.add('cp-usp-ready');

    var track = root.querySelector('.cp-usp-track');
    var items = Array.prototype.slice.call(root.querySelectorAll('.cp-usp-item'));
    if (!track || !items.length) return;

    var delay = parseInt(root.getAttribute('data-rotate-ms'), 10);
    if (isNaN(delay) || delay < 800) delay = 2000;

    // If only one item, show and bail (nothing to rotate)
    if (items.length === 1) {
        items[0].classList.add('is-active');
        return;
    }

    var idx = items.findIndex(function(el) { return el.classList.contains('is-active'); });
    if (idx < 0) idx = 0;
    items.forEach(function(el, i) { el.style.zIndex = (i === idx) ? 2 : 1; });

    function show(i) {
        items.forEach(function(el) { el.classList.remove('is-active'); el.style.zIndex = 1; });
        items[i].classList.add('is-active');
        items[i].style.zIndex = 2;
        idx = i;
    }

    var timerId = null;
    function start() {
        stop();
        timerId = setInterval(function() {
        var next = (idx + 1) % items.length;
        show(next);
        }, delay);
    }

    function stop() {
        if (timerId) { clearInterval(timerId); timerId = null; }
    }

    // Pause on hover/focus for accessibility
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Pause when not visible in viewport
    if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) start(); else stop();
        });
        }, { threshold: 0.1 });
        io.observe(root);
    } else {
        start(); // fallback
    }

    // Kick off
    show(idx);
    start();
});


/** Product Rating **/
(function () {
  // Guard: only run on PDP
  if (!window.location.pathname.includes('/products/')) return;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function findTitleEl() {
    // Common Dawn-like selectors; extend if your theme differs
    return document.querySelector('.product__title h1, .product__title, h1.product__title, .product h1.product__title');
  }

  function placeRatingUnderTitle() {
    const ratingWrap = $('#cpRatingWrapper');
    if (!ratingWrap) return;
    const titleEl = findTitleEl();
    if (!titleEl) return;

    // If it's not already immediately after the title, move it
    if (titleEl.nextElementSibling !== ratingWrap) {
      titleEl.insertAdjacentElement('afterend', ratingWrap);
    }
    ratingWrap.style.display = ''; // reveal after placed
  }

  function parseNum(txt) {
    if (!txt) return NaN;
    // handle comma decimals
    const cleaned = txt.trim().replace(',', '.');
    const match = cleaned.match(/[\d]+(\.[\d]+)?/);
    return match ? parseFloat(match[0]) : NaN;
  }

  function setRatingValue(val) {
    const span = $('#cpRatingValue');
    if (!span) return;
    const num = (typeof val === 'number') ? val : parseNum(val);
    if (!isNaN(num)) {
      span.textContent = (Math.round(num * 10) / 10).toFixed(1);
    }
  }

  function updateFromJudgeMe() {
    const domRating = document.querySelector('.jdgm-rev-widg__summary-average');
    if (!domRating) return false;
    setRatingValue(domRating.textContent);
    return true;
  }

  function observeJudgeMeOnce() {
    // If widget isn't there yet, watch for it and update once it appears.
    const container = document.body;
    let done = false;
    const mo = new MutationObserver(() => {
      if (!done && updateFromJudgeMe()) {
        done = true;
        mo.disconnect();
      }
    });
    mo.observe(container, { childList: true, subtree: true });
    // Safety timeout to stop observing eventually
    setTimeout(() => { if (!done) mo.disconnect(); }, 15000);
  }

  // Wait for the product rating wrapper to be available before executing the script
  waitForElement('.helmetPdp-product-info #cpRatingWrapper', function (cpRatingWrapper) {
    // 1) Place under title (works whether you pasted snippet in header/footer/etc.)
    placeRatingUnderTitle();

    // 2) If Judge.me is present now, use it; else keep Liquid fallback and observe
    if (!updateFromJudgeMe()) {
      // Keep Liquid fallback (already rendered)
      observeJudgeMeOnce();
    }

    // 3) Smooth scroll to reviews on click
    if (cpRatingWrapper) {
      cpRatingWrapper.addEventListener('click', function (e) {
        // If it's an anchor, prevent jumpy default behavior
        e.preventDefault();

        const reviewsSection = document.querySelector(
          '.helmetPdp-product-info #judgeme_product_reviews'
        );

        if (reviewsSection) {
          reviewsSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    }
  });


})();












/** Wait for element to appear in DOM **/
function waitForElement(selector, callback) {
  const interval = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(interval);
      callback(el);
    }
  }, 100);
}
function waitUntil(conditionFn) {
  return new Promise((resolve) => {
    function checkCondition() {
      if (conditionFn()) {
        resolve();
      } else {
        requestAnimationFrame(checkCondition);
      }
    }
    checkCondition();
  });
}




/** Add class  CUSTOMER REVIEW **/
waitForElement('.jdgm-rev-widg__title', function (titleEl) {
  const text = titleEl.textContent.trim();
  if (text === 'Customer Reviews') {
    const wrapper = titleEl.closest('.open-custom-div');
    if (wrapper) {
      wrapper.classList.add('customer-reviews-wrapper');
    }
  }
});
waitForElement('.pdp_accordian_ushing', function (pdpAccordion) {
  const wrapper = pdpAccordion.closest('.open-custom-div');
  if (wrapper) {
    wrapper.classList.add('pdp-accordion-wrapper');
  }
});






/** Wrap whishlist button and share icon **/
waitForElement('#wishlisthero-product-page-button-container', function (el) {
  // Find the nearest Shopify block wrapper
  const block = el.closest('.shopify-block.shopify-app-block');
  if (!block) return;

  // Find the CP-share-wrapper container
  const shareWrapper = document.querySelector('.CP-share-wrapper');
  if (!shareWrapper) return;

  // Move the Shopify block to the top of .CP-share-wrapper
  shareWrapper.prepend(block);
});









/** Coupon Code 
function updateCouponBoxes(coupons) {
  coupons.forEach((coupon) => {
    const codeSpan = coupon.querySelector(".coupon2-coupon-code");

    const codeNode = Array.from(codeSpan.childNodes).find(
      (node) =>
        node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ""
    );
    const code = codeNode ? codeNode.textContent.trim() : "";

    const copyBtnHTML = `<span>Click to copy</span> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 11.25H3C2.60218 11.25 2.22064 11.092 1.93934 10.8107C1.65804 10.5294 1.5 10.1478 1.5 9.75V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H9.75C10.1478 1.5 10.5294 1.65804 10.8107 1.93934C11.092 2.22064 11.25 2.60218 11.25 3V3.75M8.25 6.75H15C15.8284 6.75 16.5 7.42157 16.5 8.25V15C16.5 15.8284 15.8284 16.5 15 16.5H8.25C7.42157 16.5 6.75 15.8284 6.75 15V8.25C6.75 7.42157 7.42157 6.75 8.25 6.75Z" stroke="#1E1E1E" stroke-opacity="0.75" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;

    const copyBtn = document.createElement("button");
    copyBtn.classList.add("CP-copy-btn");
    copyBtn.innerHTML = copyBtnHTML;
    copyBtn.addEventListener("click", () => {
      navigator.clipboard.writeText(code).then(() => {
        copyBtn.textContent = "Copied!";
        setTimeout(() => (copyBtn.innerHTML = copyBtnHTML), 1500);
      });
    });
    codeSpan.appendChild(copyBtn);

    const textContainer = coupon.querySelector(".coupon2-text");
    if (!textContainer) return;

    const childNodes = Array.from(textContainer.childNodes);

    let mainText = "";
    for (let node of childNodes) {
      if (node.nodeName === "BR" || node.nodeName === "SPAN") break;
      if (node.nodeType === Node.TEXT_NODE) {
        mainText += node.textContent;
      }
    }

    mainText = mainText.trim();
    if (mainText) {
      const span = document.createElement("span");
      span.className = "coupon2-main-text";
      span.textContent = mainText;

      textContainer.insertBefore(span, textContainer.firstChild);

      const hr = document.createElement("hr");
      hr.className = "coupon2-divider";
      span.insertAdjacentElement("afterend", hr);

      childNodes.forEach((node) => {
        if (
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.includes(mainText)
        ) {
          node.textContent = node.textContent.replace(mainText, "");
        }
      });
    }
  });
}
waitUntil(() => document.querySelector(".coupon2")).then(() => {
  const coupons = document.querySelectorAll(".coupon2");
  updateCouponBoxes(coupons);
});
**/





/** Reels Ride Code 
// Swiper initialization and video handling
function initializeSwiper() {
  new Swiper(".CP-reelContainer", {
    slidesPerView: 2,
    spaceBetween: 10,
    pagination: {
      el: ".CP-reelPagination",
      clickable: true,
    },
    loop: true,
  });

  // Pause all videos
  function pauseAllVideos() {
    document.querySelectorAll("video").forEach((video) => {
      video.pause();
      const btn = video.parentElement.querySelector(".CP-playBtn");
      if (btn) btn.innerHTML = playIconSVG;
    });
  }

  // Force video to load when in view
  function forceLoadVideo(video) {
    if (video && video.dataset.src && !video.src) {
      video.src = video.dataset.src;
      video.load();
    }
  }

  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          forceLoadVideo(video);
        }
        if (!entry.isIntersecting && !video.paused) {
          video.pause();
          const btn = video.parentElement.querySelector(".CP-playBtn");
          if (btn) btn.innerHTML = playIconSVG;
        }
      });
    },
    { threshold: 0.6 }
  );

  document.querySelectorAll("video[data-src]").forEach((video) => {
    videoObserver.observe(video);
  });

  // Play/Pause logic for video
  document.querySelector(".CP-reelContainer").addEventListener("click", (e) => {
    const btn = e.target.closest(".CP-playBtn");
    if (!btn) return;
    const wrapper = btn.closest(".CP-videoWrapper");
    const video = wrapper.querySelector("video");

    if (video.paused) {
      pauseAllVideos();
      video.play().then(() => (btn.innerHTML = pauseIconSVG));
    } else {
      video.pause();
      btn.innerHTML = playIconSVG;
    }
  });
}

// Wait for the element to be ready before initializing Swiper
waitForElement(".CP-reelContainer").then(() => {
  initializeSwiper();
});

**/
document.addEventListener("DOMContentLoaded", function () {
  // Define SVG for play and pause icons
  const playIconSVG = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#e3e3e3"><path d="m380-300 280-180-280-180v360Z"></path></svg>';
  const pauseIconSVG = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#e3e3e3"><path d="M360-320h80v-320h-80v320Zm160 0h80v-320h-80v320Z"></path></svg>';

  // Wait for the element to be available
  waitForElement(".CP-reelContainer", function() {
    // Initialize Swiper once the swiper container is available
    new Swiper(".CP-reelContainer", {
      slidesPerView: 2,
      spaceBetween: 10,
      pagination: {
        el: ".CP-reelPagination",
        clickable: true,
      },
      loop: true,
    });

    // Wait for video elements to be available
    waitForElement('.CP-reelContainer video', function(video) {
      // Function to pause all videos
      function pauseAllVideos() {
        document.querySelectorAll("video").forEach((video) => {
          video.pause();
          const btn = video.parentElement.querySelector(".CP-playBtn");
          if (btn) btn.innerHTML = playIconSVG;  // Set play icon when video is paused
        });
      }

      // Function to force load video when it enters the viewport
      function forceLoadVideo(video) {
        if (video && video.dataset.src && !video.src) {
          video.src = video.dataset.src;
          video.load();
        }
      }

      // Intersection Observer to observe videos entering the viewport
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              forceLoadVideo(video);
            }
            if (!entry.isIntersecting && !video.paused) {
              video.pause();
              const btn = video.parentElement.querySelector(".CP-playBtn");
              if (btn) btn.innerHTML = playIconSVG; // Set play icon when video is paused
            }
          });
        },
        { threshold: 0.6 }
      );

      // Observe all video elements with data-src attribute
      document.querySelectorAll("video[data-src]").forEach((video) => {
        videoObserver.observe(video);
      });

      // Play/Pause Button Functionality
      document.querySelector(".CP-reelContainer").addEventListener("click", function (e) {
        const btn = e.target.closest(".CP-playBtn");
        if (!btn) return;  // Exit if the clicked element is not a play button
        const wrapper = btn.closest(".CP-videoWrapper");
        const video = wrapper.querySelector("video");

        if (video.paused) {
          // Pause other videos and play the clicked one
          pauseAllVideos();
          video.play().then(() => {
            btn.innerHTML = pauseIconSVG;  // Set pause icon when video is playing
          });
        } else {
          // Pause the video and reset button
          video.pause();
          btn.innerHTML = playIconSVG;  // Set play icon when video is paused
        }
      });
    });
  });

  // Wait for #upsell-main-cst_id and insert the .CP-reelContainer after it
  waitForElement(".pdp-accordion-wrapper", function(upsellElement) {
    // Now wait for .CP-reelContainer
    waitForElement(".CP-reelContainer", function(cpReelContainer) {
        // Insert the .CP-reelContainer after #upsell-main-cst_id
        upsellElement.insertAdjacentElement("beforebegin", cpReelContainer);
    });
  });
});






/** Brand Hightlight Images Slider Code **/
// Wait for .cp-brand-swiper element to appear in the DOM
waitForElement(".CP-swiperContainer", function() {
  // Initialize Swiper once the element is available
  new Swiper(".CP-swiperContainer", {
    loop: true,
    pagination: {
      el: ".cp-brand-pagination",
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 15,
  });
});
document.addEventListener("DOMContentLoaded", function () {
    // Wait for #upsell-main-cst_id and insert the .CP-swiperContainer after it
    waitForElement(".product__info-container .open-custom-div.customer-reviews-wrapper", function(brandSliderElement) {
      // Now wait for .CP-swiperContainer
      waitForElement(".CP-swiperContainer-sec", function(cpReelContainer) {
          // Insert the .CP-reelContainer after .product__info-container .open-custom-div.possition-17
          brandSliderElement.insertAdjacentElement("beforebegin", cpReelContainer);
      });
    });
});







// Create button
const toggleCTA = document.createElement("button");
toggleCTA.classList.add("CP-toggle-highlight-CTA");
toggleCTA.style.left = "39%";

// Default OPEN icon
toggleCTA.innerHTML = `
  <svg class="icon-sidebar-open" xmlns="http://www.w3.org/2000/svg" 
       width="20" height="20" viewBox="0 0 24 24" 
       fill="none" stroke="currentColor" stroke-width="2" 
       stroke-linecap="round" stroke-linejoin="round">
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
`;

// Insert the toggle button
target.insertAdjacentElement("beforebegin", toggleCTA);

// Ensure overlay exists
function getOverlay() {
  return document.querySelector(".CP-overlay");
}

// FIX: Attach click listener AFTER overlay appears
function attachToggleHandler() {
  const overlay = getOverlay();
  if (!overlay) return; // wait until overlay is inserted

  toggleCTA.addEventListener("click", function () {
    overlay.classList.toggle("CP-hide");

    if (overlay.classList.contains("CP-hide")) {
      // CLOSED icon ←
      toggleCTA.innerHTML = `
        <svg class="icon-sidebar-closed" xmlns="http://www.w3.org/2000/svg" 
             width="20" height="20" viewBox="0 0 24 24" 
             fill="none" stroke="currentColor" stroke-width="2" 
             stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      `;
      toggleCTA.style.left = "0%";
    } else {
      // OPEN icon →
      toggleCTA.innerHTML = `
        <svg class="icon-sidebar-open" xmlns="http://www.w3.org/2000/svg" 
             width="20" height="20" viewBox="0 0 24 24" 
             fill="none" stroke="currentColor" stroke-width="2" 
             stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      `;
      toggleCTA.style.left = "39%";
    }
  });
}

// Check repeatedly until overlay appears
const interval = setInterval(() => {
  if (getOverlay()) {
    clearInterval(interval);
    attachToggleHandler();
  }
}, 100);

